// HERO "Carrossel de banners com busca por IA" (modelo_busca = 12): é o hero 3
// (welcome3/WelcomePieces) — carrossel de banners cadastrados em tela cheia, frase e o cartão
// de busca ABAIXO do banner — mas o cartão traz a barra de frase livre da IA no lugar dos
// filtros clássicos, que abrem no botão BUSCA AVANÇADA do rodapé do cartão.
//
// Por que existe: o cs2387 queria a busca por IA sem sair do lugar. O hero 10 entrega a
// mesma barra, mas montada sobre o hero 1 — perderia o carrossel de banners e subiria o
// bloco de busca ~410px (medido: cartão do hero 10 em y=488; busca do hero 3 em y=900).
//
// Nada é duplicado: a barra é a MESMA do hero 10 (`BarraBuscaIa`, com o mesmo useBuscaIa do
// hero 4), plantada no hero 3 pelo slot `aiSearch`. Como no hero 10, os filtros clássicos
// nascem RECOLHIDOS e o cartão mostra só a frase livre; o acesso à BUSCA AVANÇADA fica logo
// ABAIXO da barra, no rodapé do cartão (Daniel 31/08 — com os dois abertos ao mesmo tempo a
// home "misturava dois modelos de busca"). O que a variante preserva do modelo 3 é o
// carrossel de banners e a posição da busca, não os filtros abertos.
//
// O default export é um ErrorBoundary com `fallback` (hero 3 puro) pra qualquer erro da barra
// não derrubar a home.
import React from 'react';
import type { HeroSectionProps } from '../../registry/types';
import WelcomePieces3, { ISelectors } from '../welcome3/WelcomePieces';
import { BarraBuscaIa } from '../welcome-padrao-ia/WelcomePadraoIa';

// Ligado pelo registry (NEW_HERO[12] em components/registry/home.ts) — recebe o superset de
// props dos heros da home; o hero 3 consome o que lhe cabe (ignora `urlBanner`: o banner dele
// vem de allDataHome.allBanners filtrado por titulo === "topo").
export type IWelcomeCarrosselIaProps = HeroSectionProps;

// `fallback` é do ErrorBoundary (abaixo) — não desce pro hero 3
const heroPropsDe = (props: IWelcomeCarrosselIaProps): ISelectors => {
    const { fallback, ...heroProps } = props;
    void fallback;
    return heroProps as unknown as ISelectors;
};

const WelcomeCarrosselIaHero: React.FC<IWelcomeCarrosselIaProps> = (props) => {
    const heroProps = heroPropsDe(props);
    const { allCities, allTypes, allTransacao, site, origin, codsite, codsite2, valores } = heroProps;
    return (
        <WelcomePieces3
            {...heroProps}
            aiSearch={({ transacao, filtrosAbertos, onTransacaoChange }) => (
                <BarraBuscaIa
                    filtrosAbertos={filtrosAbertos}
                    onTransacaoChange={onTransacaoChange}
                    allCities={allCities}
                    allTypes={allTypes}
                    allTransacao={allTransacao}
                    site={site}
                    origin={origin}
                    codsite={codsite}
                    codsite2={codsite2}
                    valores={valores}
                    transacao={transacao}
                />
            )}
        />
    );
};

// ErrorBoundary: se a barra de IA quebrar por QUALQUER motivo, cai no hero 3 PURO (o
// `fallback` da home, se vier; senão o próprio WelcomePieces3 sem a barra) — a home nunca
// fica sem hero.
class WelcomeCarrosselIa extends React.Component<IWelcomeCarrosselIaProps, { hasError: boolean }> {
    constructor(props: IWelcomeCarrosselIaProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch() {
        // silencioso de propósito: hero degrada pro modelo 3 sem quebrar a home
    }

    render() {
        const { fallback, site } = this.props;
        if (!site) return fallback ?? null;
        if (this.state.hasError) return fallback ?? <WelcomePieces3 {...heroPropsDe(this.props)} />;
        return <WelcomeCarrosselIaHero {...this.props} />;
    }
}

export default WelcomeCarrosselIa;
